export default class UserTag {
  public idUserTag: number = 0;
  public tagName: string = "";
  public externalId: string | undefined;

  // used on ui only
  public isSelected: boolean = false;
}
